import React from "../../__compat__/react/main.entry.mjs.mjs";
import { StyledTableBody } from "./Table.styles.mjs.mjs";
import { TableContext } from "./Table.context.mjs.mjs";
export const TableBody = React.forwardRef((props, ref) => {
    const tableContext = React.useContext(TableContext);
    return (React.createElement(StyledTableBody, { ...props, ref: ref, role: "rowgroup", displayMode: tableContext.displayMode }, props.children));
});
TableBody.displayName = 'TableBody';
//# sourceMappingURL=TableBody.mjs.mjs.map